import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type SearchProductDataDTO } from "~/features/search/models/SearchResultsDTO";
import { transformSrpProduct } from "~/features/search/transformers/transformSrpProduct";

export interface RecentlyViewedProductsResponseDTO {
  products?: SearchProductDataDTO[];
}

export const fetchRecentlyViewedProducts = async (showLatestProduct: boolean) => {
  const params = new URLSearchParams();
  params.set("showLast", showLatestProduct.toString());
  const url = occUrl(`/recently-viewed?${params.toString()}`);
  const response = await occFetch(url);
  if (!response.ok) {
    return [];
  }
  const searchResults = ((await response.json()) as RecentlyViewedProductsResponseDTO).products ?? [];
  return searchResults.map((item) => transformSrpProduct(item));
};
